<template>
  <div :id="id" />
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    value: number
    id?: string
    minLimit?: number
    maxLimit?: number
  }>(),
  {
    id: 'podeli-payment-widget',
    minLimit: 300,
    maxLimit: 15000,
  },
)

const init = () => {
  CartWidget.init({
    total: props.value,
    minLimit: props.minLimit,
    maxLimit: props.maxLimit,
    selectorToInject: '#' + props.id,
  })
}

onMounted(async () => {
  await waitFor(() => !!CartWidget)
  init()
})

watch(() => props.value, init)
</script>
